import { Plural } from "@lingui/react/macro";
import React from "react";
import { formatGuests } from "src/utils/common-plurals";
import { toUTCDate } from "src/utils/date";
import { getCurrentVersionAt } from "src/utils/ship";
import { DefaultNavBarQuery } from "types/graphql-types";
import Links from "./Links";

type ShipLinksProps = {
  ships: DefaultNavBarQuery["ships"]["nodes"] | undefined;
  showItemsMedia?: boolean;
  shipType: "Classic" | "Expedition";
};
const ShipLinks: React.FC<ShipLinksProps> = ({
  showItemsMedia,
  ships,
  shipType
}) => {
  const now = toUTCDate(new Date());

  const links =
    ships
      ?.filter((s) => s.shipType == shipType)
      ?.map((ship) => {
        const currentVersion =
          ship.versions && getCurrentVersionAt(ship.versions, now);

        const content = (
          <React.Fragment>
            {formatGuests(currentVersion?.passengerCount || 0)}
            <br />
            <Plural
              value={currentVersion?.crewCount || 0}
              one="# Crew"
              other="# Crew"
            />
          </React.Fragment>
        );
        return {
          _key: ship.name!,
          href: ship.fullPath!,
          label: ship.name!,
          trackingName: ship.metadata?.tracking?.name,
          content,
          image: showItemsMedia ? ship.card?.image : undefined
        };
      }) || [];

  return <Links links={links} />;
};

export default ShipLinks;
